// extracted by mini-css-extract-plugin
module.exports = {"spaceBetween":"_26KfA","waveformContainer":"_1uvNz","timeContainer":"_1DE7-","icon":"_15jK-","spinningIcon":"_1qgwQ _15jK-","spin":"cFwl0"};